/**
 * Copyright (c) 2023 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { MaterialIcon } from '@blend/enterprise-components';
import { NotaryAPI } from '../../src/api/notary/types';
import { NotaryTasks } from '../../src/pages/Notary/Room/OverviewTab/NotaryTasksCard';
import { formatIsoToLocalTime } from './formatting';

const pipelineIcons: Record<string, MaterialIcon.Props['type']> = {
  complete: 'check',
  incomplete: 'remove',
};
const appointmentTimeStatuses: Record<string, string> = {
  pendingConfirmation: 'Pending Confirmation',
  pendingPreferences: 'Pending Preferences',
};
export const getAppointmentTimeValues = (preferredTimeSlots: string[] | null, scheduleTime?: string) => {
  let status = appointmentTimeStatuses.pendingConfirmation;
  let icon = pipelineIcons.incomplete;
  const hasScheduleTime = !!scheduleTime;
  const borrowserHasNotProvidedPreferences = preferredTimeSlots === null;
  if (hasScheduleTime) {
    status = formatIsoToLocalTime(scheduleTime);
    icon = pipelineIcons.complete;
  } else if (borrowserHasNotProvidedPreferences) {
    status = appointmentTimeStatuses.pendingPreferences;
  }
  return { status, icon };
};

const completedStatuses: Record<keyof NotaryTasks, string[]> = {
  'Lender Documents': ['Tagged'],
  'Title Documents': ['Received and Tagged', 'N/A'],
};

export const getNotaryTaskStatus = (taskName: string, notaryTasks?: NotaryAPI.NotaryTask[]) => {
  const task = notaryTasks?.find(task => task.name === taskName);
  let icon: MaterialIcon.Props['type'] | undefined = pipelineIcons.incomplete;
  const status = task?.status || '';
  const isCompleted = completedStatuses[taskName as keyof NotaryTasks].includes(status);
  if (isCompleted) {
    icon = pipelineIcons.complete;
  }
  return {
    status: task?.status,
    icon,
  };
};
